const { default: Model } = require("./base/model");

class FobOrderNfFile extends Model {
  resourceName() {
    return 'fob_order_nf_files';
  }

  fields() {
    return {
      name: '',
      path: '',
      pdf_name: '',
      pdf_path: '',
      canhoto_id: '',
      canhoto_name: '',
      canhoto_path: '',
      number: '',
      serie: '',
      emission_date: '',
    }
  }
}

export default new FobOrderNfFile();